import { ModalService, SimpleMessageService, WebAppCommonModule } from "@allbesmart/web-app-common";
import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from "@angular/forms";
import { Subscription } from "rxjs";
import {
  OrderDto,
  PutOrderDto,
  TrackingDetailsDto,
} from "src/app/models/order-dto";
import { OrderService } from "src/app/services/order.service";

@Component({
    selector: "oaibox-order-tracking-details-configuration",
    templateUrl: "./order-tracking-details-configuration.component.html",
    styleUrl: "./order-tracking-details-configuration.component.css",
    imports: [WebAppCommonModule, ReactiveFormsModule],
})
export class OrderTrackingDetailsConfigurationComponent
  implements OnInit, OnDestroy
{
  @Input({ required: true }) order!: OrderDto;

  protected trackingDetailsConfigurationForm: TrackingDetailsConfigurationFormGroup;

  private updateOrderSubscription?: Subscription;

  constructor(
    private readonly orderService: OrderService,
    private readonly simpleMessageService: SimpleMessageService,
    private readonly modalService: ModalService
  ) {
    const today = new Date().toISOString().slice(0, 10); // "YYYY-MM-DD"

    this.trackingDetailsConfigurationForm = new FormGroup({
      expeditionDate: new FormControl<string | null>(today, [
        Validators.required,
      ]),
      waybill: new FormControl<string | null>(null, [Validators.required]),
      trackingUrl: new FormControl<string | null>(null, [Validators.required]),
    });
  }

  ngOnInit(): void {
    if (this.order.trackingDetails) {
      this.trackingDetailsConfigurationForm.patchValue({
        expeditionDate: this.order.trackingDetails.expeditionDate,
        waybill: this.order.trackingDetails.waybill,
        trackingUrl: this.order.trackingDetails.trackingUrl,
      });
    }
  }

  protected saveConfiguration(): void {
    if (this.trackingDetailsConfigurationForm.invalid) return;

    const trackingDetailsDto: TrackingDetailsDto = {
      expeditionDate:
        this.trackingDetailsConfigurationForm.value.expeditionDate ?? undefined,
      waybill: this.trackingDetailsConfigurationForm.value.waybill ?? undefined,
      trackingUrl:
        this.trackingDetailsConfigurationForm.value.trackingUrl ?? undefined,
    };

    const putOrderDto: PutOrderDto = {
      id: this.order.id,
      bom: this.order.bom,
      trackingDetails: trackingDetailsDto,
    };

    this.updateOrderSubscription?.unsubscribe();
    this.updateOrderSubscription = this.orderService
      .updateOrder(putOrderDto)
      .subscribe({
        next: () => {
          this.orderService.refreshOrders();
          this.simpleMessageService.showSimpleMessage({
            message: "Tracking Details updated successfully!",
            icon: "fa-solid fa-check-double",
            color: "success",
          });
          this.modalService.popModal();
        },
        error: () => {
          this.simpleMessageService.showSimpleMessage({
            message: "Failed to update Tracking Details!",
            icon: "fa-solid fa-triangle-exclamation",
            color: "danger",
          });
        },
      });
  }

  protected closeModal(): void {
    this.modalService.popModal();
  }

  ngOnDestroy(): void {
    this.updateOrderSubscription?.unsubscribe();
  }
}

type TrackingDetailsConfigurationFormGroup = FormGroup<{
  expeditionDate: FormControl<string | null>;
  waybill: FormControl<string | null>;
  trackingUrl: FormControl<string | null>;
}>;
